import { defer } from 'react-router-dom'
import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import useComplianceStore from '../store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Pay Adjustment Packages loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Pay Adjustment Packages loader'
  )

  const getPayAdjustmentPackages = useComplianceStore
    .getState()
    .getPayAdjustmentPackages()

  return defer({
    data: Promise.all([getPayAdjustmentPackages])
      .then(() => true)
      .catch((error) => {
        logger.error('Pay Adjustment Packages Promise.all error', error)
        return false
      }),
  })
}
